// extracted by css-extract-rspack-plugin
export default {"galleryEmpty":"galleryEmpty-IIiZdw","galleryEmpty_placeholder":"galleryEmpty_placeholder-iMIplr","galleryEmptyPlaceholder":"galleryEmpty_placeholder-iMIplr"};